import { useQuery, useSuspenseQuery } from "@apollo/client";
import { useMemo } from "react";
import { useParams } from "react-router";
import { PROCESSED_MANIFESTS_QUERY } from "routes/Customer/Waste/Manifests/api";

export const useProcessedManifest = (processedManifestId: string | undefined) => {
  const { tenantId } = useParams<{ tenantId: string }>();
  const { data, loading } = useQuery(PROCESSED_MANIFESTS_QUERY, {
    variables: {
      search: `tenantId:${tenantId} id:${processedManifestId}`,
      page: 0,
      pageSize: 1,
    },
    skip: !tenantId || !processedManifestId,
  });

  return useMemo(() => {
    return {
      data,
      loading,
      processedManifest: data?.processedManifests?.items?.[0],
    };
  }, [data, loading]);
};

export const useProcessedManifestSuspense = (processedManifestId: string | undefined) => {
  const { tenantId } = useParams<{ tenantId: string }>();
  const { data } = useSuspenseQuery(PROCESSED_MANIFESTS_QUERY, {
    variables: {
      search: `tenantId:${tenantId} id:${processedManifestId}`,
      page: 0,
      pageSize: 1,
    },
    skip: !tenantId || !processedManifestId,
  });

  return {
    data,
    processedManifest: data?.processedManifests?.items?.[0],
  };
};
